import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

const performanceData = [
  { month: "Jan", hires: 30, applications: 200 },
  { month: "Feb", hires: 40, applications: 250 },
  { month: "Mar", hires: 50, applications: 300 },
  { month: "Apr", hires: 70, applications: 400 },
  { month: "May", hires: 90, applications: 500 },
];

const PerformanceChart = () => {
  return (
    <div className="bg-gradient-to-br from-blue-100 to-blue-300 p-6 rounded-xl shadow-lg mt-6 max-w-full overflow-hidden">
      <h2 className="text-3xl font-extrabold text-blue-800">Performance Overview</h2>
      <p className="text-blue-700 mt-2">
        Hiring trends and application success rates over the past months.
      </p>
      <div className="mt-6 h-80 sm:h-96 lg:h-[300px] bg-white rounded-lg p-4 shadow-md">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={performanceData}>
            <defs>
              <linearGradient id="hiresGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#007BFF" stopOpacity={0.8} />
                <stop offset="95%" stopColor="#007BFF" stopOpacity={0.2} />
              </linearGradient>
              <linearGradient id="applicationsGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#FFA500" stopOpacity={0.8} />
                <stop offset="95%" stopColor="#FFA500" stopOpacity={0.2} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#cccccc" />
            <XAxis dataKey="month" tick={{ fill: "#555555", fontSize: 12 }} />
            <YAxis tick={{ fill: "#555555", fontSize: 12 }} />
            <Tooltip
              contentStyle={{
                backgroundColor: "#f9f9f9",
                borderRadius: "10px",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              }}
              itemStyle={{ color: "#333" }}
              labelStyle={{ color: "#007BFF", fontWeight: "bold" }}
            />
            <Legend
              verticalAlign="top"
              align="right"
              wrapperStyle={{ top: -10, right: 0, fontSize: 14, color: "#555" }}
            />
            <Line
              type="monotone"
              dataKey="hires"
              stroke="url(#hiresGradient)"
              strokeWidth={3}
              activeDot={{ r: 10, stroke: "#007BFF", strokeWidth: 2 }}
            />
            <Line
              type="monotone"
              dataKey="applications"
              stroke="url(#applicationsGradient)"
              strokeWidth={3}
              activeDot={{ r: 10, stroke: "#FFA500", strokeWidth: 2 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default PerformanceChart;
